import {Injectable} from '@angular/core';
import {SigningServiceHttp} from '../../signing-service';

export interface Chat {
  message : string;
  attachment? : string;
}

@Injectable({
  providedIn: 'root'
})
export class ActivityLogService {

  constructor(
      private http: SigningServiceHttp
    ) { }

    /**
     * get the document detail for signing
     * @param role_id 
     * @returns 
     */
    getActivityLogs(role_id:number){
      return this.http.get(`sign-document/${role_id}/activity-log`);
    }

    /**
     * send message to all parties
     * @param role_id 
     * @param chat 
     * @returns 
     */
    sendMessage(role_id:number, chat:FormData){
      return this.http.post(`sign-document/${role_id}/activity-chat`, chat);
    }



    /**
     * 
     * @param roleId 
     * @param formData 
     * @returns 
     */
    updateActivityStatus(roleId: number, formData: {
        activity_ids: number[]
    }){
        //TODO: missing API DOC description
      return this.http.post(`sign-document/${roleId}/activity-chat-status`, formData);
    }

}
